import { gql } from "@apollo/client";

export const RECHAZAR_TAREA_RI = gql`
    mutation RechazarTarea(
        $idDatosGenerales: Int!
    ) {
        rechazoMisTareas(
            idDatosGenerales: $idDatosGenerales
        ) {
            idMisTareas
        }
    }
`;